import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Form from 'react-jsonschema-form';
import './styles.scss';
import { Button } from '@patternfly/react-core';

function JSONSchemaForm({ buttonProps, ...props }) {
  const { t } = useTranslation();
  return (
    <Form {...props}>
      <Button variant="secondary" {...buttonProps} type="submit">
        {t('Submit')}
      </Button>
    </Form>
  );
}

JSONSchemaForm.propTypes = {
  buttonProps: PropTypes.object,
  schema: PropTypes.object.isRequired,
};

JSONSchemaForm.defaultProps = {
  buttonProps: {},
};

export default JSONSchemaForm;
